class ProductRating {
	constructor() {
		this.init();
	}

	init() {
		const productRatingLink = document.getElementById('productRating');

		if (productRatingLink) {
			productRatingLink.addEventListener(
				'click',
				this.scrollToReviews.bind(this),
			);
		}

		if ('URLSearchParams' in window) {
			const urlParams = new URLSearchParams(window.location.search);
			this.pageLoadScrollToReviews(urlParams);
		}
	}

	pageLoadScrollToReviews(urlParams) {
		if (urlParams.get('scrollTo') === 'reviewsSection') {
			this.scrollToReviews();
		}
	}

	scrollToReviews(event) {
		if (event) event.preventDefault();

		const productReviewsSection = document.getElementById('productReviews');

		if (productReviewsSection) {
			const productHeader = document.getElementById('productHeader');
			const offsetHeight = productHeader ? productHeader.offsetHeight : 0;
			const scrollY = productReviewsSection.offsetTop - offsetHeight;

			this.openReviewsPanel();

			window.scrollTo({
				top: scrollY,
				behavior: 'smooth',
			});
		}
	}

	openReviewsPanel() {
		const productReviewsHeader = document.getElementById(
			'headerproductReviews',
		);
		const productReviewsContent = document.getElementById(
			'contentproductReviews',
		);

		productReviewsHeader.setAttribute('aria-expanded', 'true');
		productReviewsContent.classList.add('show');
	}
}

export default ProductRating;
